export class AccountRequest {
  constructor(data = {}) {
    this.email = data?.email;
    this.first_name = data?.firstName;
    this.last_name = data?.lastName;
    this.password = data?.password;
    this.password_confirmation = data?.passwordConfirmation;
  }
}
